import type { BigNumber } from 'ethers';
import { addAuthority, removeAuthority, withdrawToken } from '../connectors/scWallet';
import type { IBuilderReturnData } from '../types';

export const buildWithdrawTokenFromSCWCallData = async (
	tokenAddress: string,
	withdrawFundsTokenAmount: BigNumber,
	walletAddress: `0x${string}`
): Promise<IBuilderReturnData> => {
	const targetArray: Array<string> = [];
	const callDataArray: Array<string> = [];

	const withdrawTokenCallData = await withdrawToken(
		tokenAddress,
		withdrawFundsTokenAmount,
		walletAddress
	);

	targetArray.push(withdrawTokenCallData._target);
	callDataArray.push(withdrawTokenCallData._callData);

	return {
		_targetArray: targetArray,
		_callDataArray: callDataArray
	};
};

export const buildAddAuthorityCallData = async (
	walletAddress: `0x${string}`
): Promise<IBuilderReturnData> => {
	const targetArray: Array<string> = [];
	const callDataArray: Array<string> = [];

	const addAuthorityCallData = await addAuthority(walletAddress);

	targetArray.push(addAuthorityCallData._target);
	callDataArray.push(addAuthorityCallData._callData);

	return {
		_targetArray: targetArray,
		_callDataArray: callDataArray
	};
};

export const buildRemoveAuthorityCallData = async (
	walletAddress: `0x${string}`
): Promise<IBuilderReturnData> => {
	const targetArray: Array<string> = [];
	const callDataArray: Array<string> = [];

	const removeAuthorityCallData = await removeAuthority(walletAddress);

	targetArray.push(removeAuthorityCallData._target);
	callDataArray.push(removeAuthorityCallData._callData);

	return {
		_targetArray: targetArray,
		_callDataArray: callDataArray
	};
};
